import HttpClient from '../HttpService';

function list() {
    return HttpClient.get('/workergroups');
}

export default {
    list
};
